import styled from "styled-components";

export const Wrapper = styled.div`
  .lms {
    position: relative;
    padding-top: 100px;
    background: #722e0a;
    height: 65vh;
    overflow: hidden;

    &__building {
      width: 100%;
      position: absolute;
      z-index: 1;
      bottom: 0;
    }
    &__fire {
      width: auto;
      height: 80%;
      position: absolute;
      bottom: 0;
      z-index: 5;
    }
    &__arrow {
      width: 100%;
      position: absolute;
      @media (max-width: 500px) {
        left: 5%;
      }
    }
    &__text {
      position: absolute;
      left: 50%;
      top: 55%;
      transform: translate(-50%, -50%);
      font-family: "coolvetica_rg";
      color: white;
      z-index: 0;
      @media (max-width: 500px) {
        left: 60%;
      }

      &__first,
      &__third {
        font-size: 9vw;
        line-height: 7vw;
        margin-bottom: -10px;
      }

      &__second {
        font-size: 30vw;
        line-height: 24vw;
      }
    }
  }
`;
